import { productSliderInit } from "./product"
import { mainSliderInit } from "./main-slider"

export const mainInit = () => {
  productSliderInit()
  mainSliderInit()
}
